import templateUrl from './detectorWizardRecipients.tpl.html';

/**
 * The recipients editor component shows the rule notification widget
 * and allows user to update notifications for the rule.
 */
angular.module('signalview.detector.wizard').component('detectorWizardRecipientsEditor', {
    bindings: {
        detector: '<',
        rule: '<',
        isNewRule: '<',
        isReminderNotificationValid: '=',
        onRecipientsSelect: '&',
        proceed: '&',
        done: '&',
    },
    templateUrl,
    controller: [
        '$scope',
        'featureEnabled',
        function ($scope, featureEnabled) {
            let previousWatch;
            const ctrl = this;
            ctrl.$onInit = $onInit;
            ctrl.isReminderNotificationCorrect = true;

            function $onInit() {
                $scope.onReminderNotificationChange = function (reminderNotification) {
                    ctrl.rule.reminderNotification = reminderNotification;
                    ctrl.isReminderNotificationCorrect =
                        ctrl.isReminderNotificationValid(reminderNotification);

                    $scope.$applyAsync();
                };
                $scope.onSkipClearNotificationStatesChange = function (
                    skipClearNotificationStates
                ) {
                    ctrl.rule.skipClearNotificationStates = skipClearNotificationStates;

                    $scope.$applyAsync();
                };
                // copy notifications to local variable
                $scope.recipients = angular.copy(ctrl.rule.notifications || []);
                $scope.isReminderNotificationEnabled = featureEnabled(
                    'detectorsRepeatedNotificationReminderOldWizard'
                );
                $scope.isAlertClearNotificationSettingsFeatureEnabled = featureEnabled(
                    'detectorsAlertClearNotificationSettings'
                );
                // pass modified notifications to parent binding
                if (previousWatch) {
                    previousWatch();
                }
                previousWatch = $scope.$watch(
                    'recipients',
                    function (nval, oval) {
                        if (nval && !angular.equals(nval, oval)) {
                            ctrl.onRecipientsSelect({ recipients: $scope.recipients });
                        }
                        if (nval.length === 0 && $scope.isReminderNotificationEnabled) {
                            ctrl.rule.reminderNotification = undefined;
                        }
                        if (nval.length === 0) {
                            ctrl.rule.skipClearNotificationStates = undefined;
                        }
                    },
                    true
                );
            }
        },
    ],
});
